import React from "react";
import { Typography, Box, Button, Chip } from "@mui/material";
import ServiceProductCard from "./ServiceProductCard";
import ServiceVideo from "./ServiceVideo";

export const Service = () => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: { xs: "305px", md: "1280px" },
				zIndex: 3,
				// p: "20px 20px",
				gap: 4,
				background: "#fff",
				justifyContent: "center",
				alignItems: "center",
				alignSelf: "center",
				alignContent: "center",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
				}}
			>
				<Chip
					label="Our Services"
					variant="filled"
					sx={{
						borderRadius: 4,
						fontSize: "18px",
						color: "#667085",
						width: "200px",
					}}
				/>
				<Typography
					fontWeight={600}
					fontSize={{ xs: 32, md: 48 }}
					color="#000000"
				>
					{"Sell Smarter, Not Harder"}
				</Typography>
				<Typography
					fontWeight={400}
					fontSize={{ xs: 15, md: 18 }}
					color="#667085"
				>
					{
						"We’ve done the research for you—get access to winning products, market"
					}
				</Typography>
				<Typography
					fontWeight={400}
					fontSize={{ xs: 15, md: 18 }}
					color="#667085"
				>
					{"insights, and supplier connections to start selling instantly."}
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					width: "100%",
					gap: { xs: 2, md: 4 },
				}}
			>
				<ServiceVideo />
				<ServiceProductCard />
			</Box>
		</Box>
	);
};
